<!--资源中心-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="top-box">
                <homeHead ref="homeHead" />
            </div>
            <div class="course-container">
                <div class="left-menu-container">
                    <course-menu :item-num="this.activeItem"
                                 @change-item="changeItem"/>
                </div>
                <!--高水平示范课-->
                <div v-if="activeItem==='1'"  class="right-content-container">
                    <page-course title="高水平示范课"
                                 courseType="1"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--区本课程-->
                <div v-if="activeItem==='2'"  class="right-content-container">
                    <page-course title="区本课程"
                                 courseType="2"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--校本课程-->
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <page-course title="校本课程"
                                 courseType="3"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--课后服务-->
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <page-course title="课后服务"
                                 courseType="4"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--人工智能-->
                <div v-if="activeItem==='5'"  class="right-content-container">
                    <page-course title="人工智能"
                                 courseType="5"
                                 :course-mode="this.activeMode"
                                 @change-mode="changeMode"/>
                </div>
                <!--互动课件-->
                <div v-if="activeItem==='6'"  class="right-content-container">
                    <courseware-list title="互动课件"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='8'"  class="right-content-container">
                    <humanity-museum-home title="人文美育"
                                     :course-mode="this.activeMode"
                                     @change-mode="changeMode"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import homeFooter from "@/components/homeFooter";
import dataEmpty from "@/components/dataEmpty.vue";
import courseMenu from "@/components/resourceCentre/courseMenu";
import pageCourse from "@/components/resourceCentre/pageCourse";
import coursewareList from "@/components/resourceCentre/coursewareList";
import humanityMuseumHome from "@/components/resourceCentre/humanityMuseumHome";
import {oauthCode} from "@/api/user/login";
export default {
    components: {
        pageCourse,
        courseMenu,
        dataEmpty,
        homeHead,
        homeFooter,
        coursewareList,
        humanityMuseumHome
    },
    name: "homeResourceCentre",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeResourceCentre",
            activeItem:"1",
            activeMode:"page",
            userInfo: {},
        }
    },
    computed: {},
    watch: {},
    created() {
        this.userInfo = JSON.parse(this.$storage.get("userInfo"))
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            if (item==='7'){
                if (!this.userInfo.isAide) {
                    this.$message.error("暂无权限")
                } else {
                    oauthCode({
                        clientId: 'xhly2024855631', username: this.userInfo.username
                    }).then(res => {
                        if (res.data.data) {
                            window.open('https://web.edumate.cn/thirdpart?platform=sxdtjz&code=' + res.data.data + '&client_id=xhly2024855631&response_type=code', '_blank')
                        } else {
                            this.$message.error("授权失败")
                        }
                    })
                }
                return;
            }
            //人文美育
            // if (item==='8'){
            //     window.open('https://m.boyameiyu.com/', '_blank')
            //     return;
            // }
            if (item==='9'){
                window.open('https://basic.smartedu.cn/', '_blank')
                return;
            }
            this.activeItem = item;
            this.activeMode = this.pageMode;
            this.$store.commit("params/setJumpParams", {});

        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>